<div class="tw-p-8 tw-flex">
  <img class="new-logo-themed" alt="Bitwarden" />
  <div class="spinner-container tw-justify-center">
    <bit-icon
      name="bwi-spinner"
      class="bwi-spin bwi-3x tw-text-muted"
      [ariaLabel]="'loading' | i18n"
    ></bit-icon>
  </div>
</div>
